import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSales } from 'app/mocks/data/transactions/sales'

import { api, assets } from 'app/utils/constants'

export const getReceipt = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.transactions.sales.RECEIPT}`,
    async ({ params }) => {
        const { id } = params

        const saleFound = allSales.find((sale) => sale.id.toString() === id)

        const blob = await fetch(assets.mocks.RECEIPT).then((response) =>
            response.blob(),
        )

        // Not found
        if (!saleFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return new HttpResponse(blob, {
            headers: {
                'content-type': 'application/pdf',
            },
        })
    },
)
